import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { PoolMaintenance } from '../types';

import {
  createPoolMaintenance,
  editPoolMaintenance
} from 'RestAPIs/poolMaintenance';

import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

export const useSavePoolMaintenance = (
  handleClose: () => void,
  rowData?: PoolMaintenance
) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation(
    rowData?.id ? editPoolMaintenance : createPoolMaintenance,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['poolMaintenance', 'list']
        });
        handleClose();
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar(t('saveError', { name: 'poolMaintenance' }));
      }
    }
  );
};
